var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_44839)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 966,
    transform: "translate(-406 -87)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_184_44839)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -406,
    y: -87,
    width: 1280,
    height: 118,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.8917 16.0005H1.10838C0.958962 16.0047 0.81116 15.9686 0.680558 15.8958C0.549955 15.8231 0.441392 15.7165 0.36631 15.5873C0.291229 15.458 0.252412 15.3109 0.25395 15.1614C0.255489 15.0119 0.297326 14.8656 0.375051 14.738L8.27839 1.04212C8.35153 0.915445 8.45673 0.810257 8.5834 0.737123C8.71008 0.66399 8.85378 0.625488 9.00005 0.625488C9.14633 0.625488 9.29002 0.66399 9.4167 0.737123C9.54338 0.810257 9.64857 0.915445 9.72172 1.04212L17.6251 14.738C17.7028 14.8656 17.7446 15.0119 17.7462 15.1614C17.7477 15.3109 17.7089 15.458 17.6338 15.5873C17.5587 15.7165 17.4501 15.8231 17.3195 15.8958C17.1889 15.9686 17.0411 16.0047 16.8917 16.0005Z",
    fill: "#FFC74F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83464 13.0835C9.83464 13.2483 9.78576 13.4094 9.69419 13.5465C9.60263 13.6835 9.47248 13.7903 9.32021 13.8534C9.16793 13.9165 9.00038 13.933 8.83873 13.9008C8.67708 13.8687 8.52859 13.7893 8.41205 13.6728C8.2955 13.5562 8.21614 13.4077 8.18398 13.2461C8.15183 13.0844 8.16833 12.9169 8.2314 12.7646C8.29448 12.6123 8.40129 12.4822 8.53833 12.3906C8.67537 12.299 8.83649 12.2502 9.0013 12.2502C9.22232 12.2502 9.43428 12.338 9.59056 12.4942C9.74684 12.6505 9.83464 12.8625 9.83464 13.0835ZM9.38714 5.5835H8.61547C8.55817 5.58335 8.50146 5.59503 8.44888 5.61779C8.39629 5.64056 8.34897 5.67392 8.30987 5.7158C8.27076 5.75768 8.24072 5.80718 8.22161 5.8612C8.2025 5.91521 8.19473 5.97259 8.1988 6.02975L8.55589 11.0297C8.56338 11.135 8.61057 11.2336 8.68791 11.3054C8.76525 11.3773 8.86699 11.4171 8.97255 11.4168H9.03005C9.13562 11.4171 9.23735 11.3773 9.3147 11.3054C9.39204 11.2336 9.43923 11.135 9.44672 11.0297L9.8038 6.02975C9.80787 5.97259 9.80011 5.91521 9.781 5.8612C9.76189 5.80718 9.73184 5.75768 9.69274 5.7158C9.65363 5.67392 9.60631 5.64056 9.55373 5.61779C9.50115 5.59503 9.44444 5.58335 9.38714 5.5835Z",
    fill: "url(#paint0_linear_184_44839)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_184_44839",
    x: -414,
    y: -96,
    width: 1296,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.360784 0 0 0 0 0.960784 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_184_44839"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_184_44839",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_44839",
    x1: 9.0013,
    y1: 5.5835,
    x2: 9.0013,
    y2: 13.9168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_44839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 966,
    fill: "white",
    transform: "translate(-406 -87)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.ec9e1bdb.svg";
export { ForwardRef as ReactComponent };